import axios from './request'
//请求方法封装
export function get(url) {

    return function (params) {
        return axios.cats.get(url, {
            params
        }).then(res => {

            return res

        }).catch(error => {
            console.log(error);
        })
    }
}
//url拼接
export function get0(url) {

    return function (id) {
        return axios.cats.get(url + id).then(res => {

            return res

        }).catch(error => {
            console.log(error);
        })
    }
}
export function get2(url) {

    return function (id) {
        return axios.cats.get(url + '?index=' + id).then(res => {

            return res

        }).catch(error => {
            console.log(error);
        })
    }
}



export function post(url) {

    return function (data) {
        return axios.cats.post(url, data).then(res => {

            return res

        }).catch(error => {
            console.log(error);
        })
    }
}
export function Delete(url) {

    return function (data) {
        return axios.cats.delete(url, {
            data: JSON.stringify(data)
        }).then(res => {

            return res

        }).catch(error => {
            console.log(error);
        })
    }
}

export function put(url) {

    return function (data) {
        return axios.cats.put(url,
            data
        ).then(res => {

            return res

        }).catch(error => {
            console.log(error);
        })
    }
}